import { useTranslation } from 'react-i18next';
import type { AdminEvent } from '@/types/admin';

/* Source and lock state as small-caps text labels; the words carry the meaning, not a pill. */
export function SourceBadge({ event }: { event: AdminEvent }) {
  const { t } = useTranslation('admin');
  return (
    <span className="inline-flex flex-wrap items-center gap-x-2 gap-y-0.5">
      <span className="status-label text-ink-2">
        {t(`sources.${event.source}`)}
      </span>
      {event.admin_locked === 1 && (
        <span
          className="status-label text-accent-text"
          title={t('status.lockedHint')}
        >
          {t('status.locked')}
        </span>
      )}
    </span>
  );
}

export function StatusBadge({ enabled }: { enabled: boolean }) {
  const { t } = useTranslation('admin');
  if (enabled) {
    return <span className="status-label text-success">{t('status.visible')}</span>;
  }
  return <span className="status-label text-danger">{t('status.hidden')}</span>;
}
